import { SvgIcon } from "@mui/material";
import { IIconProps } from "@/models";
import { memo } from "react";

const CommentIcon = ({ sx, ...otherProps }: IIconProps) => {
  return (
    <SvgIcon
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      sx={{
        fontSize: "inherit",
        ...sx,
      }}
      {...otherProps}
    >
      <path
        d="M9.56756 6.84375C8.91868 6.84651 8.39404 7.3739 8.39404 8.02003C8.39404 8.66616 8.91868 9.19355 9.56756 9.19907C10.2192 9.19907 10.7494 8.67168 10.7494 8.02003C10.7494 7.36838 10.222 6.84375 9.56756 6.84375ZM14.281 6.84375C13.6321 6.84651 13.1075 7.37391 13.1075 8.02279C13.1075 8.66892 13.6321 9.19631 14.281 9.20183C14.9326 9.20183 15.4628 8.67444 15.4628 8.02279C15.4628 7.36838 14.9326 6.84375 14.281 6.84375ZM18.9916 6.84375C18.3427 6.84651 17.8181 7.37391 17.8181 8.02279C17.8181 8.66892 18.3427 9.19631 18.9916 9.20183C19.6433 9.20183 20.1734 8.67444 20.1734 8.02279C20.1762 7.36838 19.646 6.84375 18.9916 6.84375Z"
        fill="currentColor"
      ></path>
      <path
        d="M21.9932 12.9848C21.9932 13.8325 21.3167 14.5201 20.4884 14.5201H19.047L17.3212 16.5662L15.4933 14.5201H8.09323C7.2621 14.5201 6.58836 13.8325 6.58836 12.9848V4.06886C6.58836 3.22117 7.26486 2.53362 8.09323 2.53362H20.4884C21.3195 2.53362 21.9932 3.22117 21.9932 4.06886V12.9848ZM20.9743 1.00391H7.61001C6.21836 1.00391 5.0835 2.1581 5.0835 3.58013V13.4736C5.0835 14.8929 6.2156 16.0498 7.61001 16.0498H14.7091L16.5591 18.1207C16.7579 18.3416 17.0368 18.4686 17.3461 18.4686C17.6443 18.4631 17.9287 18.3306 18.122 18.0986L19.8533 16.0498H20.9743C22.366 16.0498 23.5009 14.8956 23.5009 13.4736V3.58013C23.4981 2.1581 22.366 1.00391 20.9743 1.00391Z"
        fill="currentColor"
      ></path>
      <path
        d="M14.6788 18.4303H8.51299L6.60222 20.3632L4.79914 18.4303H3.29428C2.42725 18.4303 1.72038 17.7787 1.72038 16.9807V8.55897C1.72038 7.75821 2.42725 7.10933 3.29428 7.10933C3.72503 7.10933 4.07847 6.78626 4.07847 6.38865C4.07847 5.99103 3.72779 5.66797 3.29428 5.66797H2.78621C1.33105 5.66797 0.146484 6.75865 0.146484 8.10061V17.4446C0.146484 18.7865 1.33105 19.8772 2.78621 19.8772H3.95697L5.76557 21.8128C5.9699 22.031 6.26535 22.158 6.57737 22.1635H6.59394C6.90043 22.1635 7.19312 22.0448 7.40022 21.8349L9.33307 19.8772H14.6788C15.1095 19.8772 15.463 19.5542 15.463 19.1565C15.463 18.7534 15.1123 18.4303 14.6788 18.4303Z"
        fill="currentColor"
      ></path>
    </SvgIcon>
  );
};
export default memo(CommentIcon);
